'use client'

import { useEffect } from 'react'
import { initializeApiKeys } from '@/service/api-key-initialization'

const ApiKeyInitializer = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    // 暂时不初始化API Key，避免重复调用
    // initializeApiKeys()
  }, [])

  return children
}

export default ApiKeyInitializer
